import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';

import MatrixAttributesSortableItem from './MatrixAttributesSortableItem';

const MatrixAttributesSortableList = SortableContainer(
  ({ name, data, isEditable, onChangeText, onKeyPress }) => (
    <ul className="matrix-attributes__list">
      {data.map((attribute, index) => (
        <MatrixAttributesSortableItem
          // eslint-disable-next-line react/no-array-index-key
          key={`attribute-${index}`}
          attribute={attribute}
          name={name}
          index={index}
          i={index}
          type={attribute.type || 'set_value'}
          isEditable={isEditable}
          onChangeText={onChangeText}
          onKeyPress={onKeyPress}
        />
      ))}
    </ul>
  )
);

export default MatrixAttributesSortableList;
